var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.111,
    height: 117,
    viewBox: "0 0 117.111 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#FADAD6;}.b{fill:#fff;}.c{fill:#A02524;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-749 -1420)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 58.5,
    cy: 58.5,
    r: 58.5,
    transform: "translate(749 1420)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 71,
    height: 13,
    transform: "translate(785 1430)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 81,
    height: 13,
    transform: "translate(785 1451)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 81,
    height: 13,
    transform: "translate(785 1472)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 81,
    height: 13,
    transform: "matrix(1, -0.017, 0.017, 1, 784.896, 1494.153)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 71,
    height: 13,
    transform: "translate(785 1515)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.a542aa1cabc005546ed365cb3cd6e5ba.svg";
export { ForwardRef as ReactComponent };